export enum TickAction {
  Nothing = 1,
  Heartbeat = 2,
  TestRequest = 3,
  TerminateOnError = 4,
  WaitLogoutConfirmExpired = 5,
  Stop = 6
}
